import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";

export function EarningAppVideo({ videoId, title }: { videoId: string; title: string }) {
  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  useEffect(() => { setReady(true); }, []);
  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-lg border border-border bg-muted">
      {playing ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`}
          title={title}
          className="absolute inset-0 h-full w-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        />
      ) : (
        <>
          <img src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`} alt={title} width={480} height={360} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
          <Button type="button" variant="secondary" disabled={!ready} onClick={() => setPlaying(true)} aria-label={`Play ${title}`} className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 shadow-lg">
            <Play aria-hidden="true" /> Play video
          </Button>
        </>
      )}
    </div>
  );
}